import { __ } from '@wordpress/i18n';
import { Slot } from '@wordpress/components';
import { DokanRequestQuote } from '../../types/quote';
import { Fragment } from '@wordpress/element';
import { QUOTE_LIST_SLOTS } from '../Common/QuoteListSlot';

declare const dokanRequestQuote: DokanRequestQuote;

export interface EmptyQuoteProps {
    shopUrl?: string;
    message?: string;
    buttonText?: string;
}

const EmptyQuote = ( {
    shopUrl = '',
    buttonText = '',
    message = __( 'No quote has been made yet.', 'dokan' ),
}: EmptyQuoteProps ) => {
    return (
        <Fragment>
            { /* Before quote list empty slot */ }
            <Slot name={ QUOTE_LIST_SLOTS.BEFORE_LIST_EMPTY } />

            <div className="dokan-btn-theme pointer-events-none text-white p-3 rounded flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <div className="bg-white rounded-full p-1">
                        <svg
                            className="w-3 h-3 active-title"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={ 3 }
                        >
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                    </div>
                    <span className="text-base font-medium">{ message }</span>
                </div>
                { shopUrl && buttonText && (
                    <a
                        href={ shopUrl }
                        className="pointer-events-auto bg-white hover:bg-white text-gray-700 hover:text-gray-800 text-sm cursor-pointer font-medium px-4 py-2 rounded hover:bg-teal-600"
                    >
                        { buttonText }
                    </a>
                ) }
            </div>

            { /* After quote list empty slot */ }
            <Slot name={ QUOTE_LIST_SLOTS.AFTER_LIST_EMPTY } />
        </Fragment>
    );
};

export default EmptyQuote;
